import i18n from '@/plugins/i18n'

export function formatValue (value: number|string|null, decimalPlaces = 0, fallback = ''): string {
  if (value === null) {
    return fallback
  } else {
    return Number(value).toLocaleString(i18n.locale, { minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces })
  }
}
